let triggerClass = ".Filters-sort-submenu-trigger";
let activeClassName = "is-open";
let containerElement = document.querySelectorAll(".Filters-sort-item");
let sortBySelect = document.getElementById("SortBy");

const gatherElements = () => {
    triggerClass = ".Filters-sort-submenu-trigger";
    activeClassName = "is-open";
    containerElement = document.querySelectorAll(".Filters-sort-item");
    sortBySelect = document.getElementById("SortBy");
};

const closeSortMenus = () => {
    containerElement.forEach(item => {
        item.classList.remove(activeClassName);
        const trigger = item.querySelector(triggerClass);
        if (trigger) trigger.setAttribute("aria-expanded", "false");
    });
};

const toggleOpen = () => {
    containerElement.forEach(item => {
        item.classList.toggle(activeClassName);
    });
};

const selectSort = value => {
    if (!sortBySelect || !value) return;

    sortBySelect.value = value;

    const formComponent = document.querySelector("facet-filters-form");
    const form = document.getElementById("FacetFiltersForm");

    if (
        formComponent &&
        form &&
        typeof formComponent.createSearchParams === "function"
    ) {
        const searchParams = formComponent.createSearchParams(form);
        formComponent.onSubmitForm(searchParams);
    } else {
        sortBySelect.dispatchEvent(new Event("input", { bubbles: true }));
    }

    closeSortMenus();
};

const isVisible = () =>
    containerElement[0] &&
    containerElement[0].classList.contains(activeClassName);

function hideOnClickOutside() {
    const removeClickListener = () => {
        document.removeEventListener("click", outsideClickListener);
    };

    const outsideClickListener = event => {
        containerElement.forEach(item => {
            if (!item.contains(event.target) && isVisible()) {
                item.classList.remove(activeClassName);
                const trigger = item.querySelector(triggerClass);
                if (trigger) trigger.setAttribute("aria-expanded", "false");
                removeClickListener();
            }
        });
    };

    document.addEventListener("click", outsideClickListener);
}

function bindSortControls() {
    gatherElements();

    document.querySelectorAll(triggerClass).forEach(item => {
        if (item.dataset.sortBound === "true") return;
        item.dataset.sortBound = "true";

        item.addEventListener("click", e => {
            e.preventDefault();
            e.stopPropagation();
            const expanded = item.getAttribute("aria-expanded") !== "true";
            item.setAttribute("aria-expanded", expanded ? "true" : "false");
            toggleOpen();
            if (expanded) hideOnClickOutside();
        });
    });

    document
        .querySelectorAll(".Filter-sort-submenu-item .Filter-sort")
        .forEach(item => {
            if (item.dataset.sortBound === "true") return;
            item.dataset.sortBound = "true";

            item.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                selectSort(e.currentTarget.dataset.optionValue);
            });
        });
}

bindSortControls();

document.addEventListener("facet-pages-rendered", () => {
    bindSortControls();
});
